import Vue from 'vue'
import VueRouter from 'vue-router'
import PageNotFound from '../components/PageNotFound.vue'
import Layout from '../components/layouts/Index.vue'
import Login from '../views/auth/Login.vue'
import Logout from '../views/auth/Logout.vue'
import Registration from '../views/auth/Registration.vue'
import Activated from '../views/auth/Activated.vue'
import ProfileApplicationList from '../views/profile/application/List.vue';
import ProfilePersonal from '../views/profile/Personal.vue';
import Store from '@/_store'

const PasswordRecovery = () => import('../views/auth/PasswordRecovery.vue');
const PasswordReset = () => import('../views/auth/PasswordReset.vue');
const ProfileApplicationDetail = () => import('../views/profile/application/Detail.vue');
const ProfileApplicationCreate = () => import('../views/profile/application/Create.vue');
const ProfileApplicationReset = () => import('../views/profile/application/Reset.vue');
const ProfileSettings = () => import('../views/profile/Settings.vue');
const OperatorList = () => import('../views/operator/List.vue');
const AdminList = () => import('../views/operator/Admin.vue');
const OperatorProfile = () => import('../views/operator/Profile.vue');
const OperatorProtector = () => import('../views/operator/Protector.vue');
const OperatorCheckApplication = () => import('../views/operator/CheckApplication.vue');

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: "", name: "home", redirect: {
            name: "registration"
          }
        },
        {
          path: '/login', name: 'login', component: Login,
          meta: {
            title: 'Вход в личный кабинет',
            canViewGuest: true
          }
        },
        {
          path: '/logout', name: 'logout', component: Logout,
          meta: {
            title: 'Выход из личного кабинета',
            canViewAuth: true
          }
        },
        {
          path: '/registration', name: 'registration', component: Registration,
          meta: {
            title: 'Регистрация для подачи заявлений ONLINE',
            canViewGuest: true
          }
        },
        {
          path: '/activated/:uid/:token', name: 'activated', component: Activated, props: true,
          meta: {
            title: 'Подтверждение электронной почты',
            canViewAll: true
          }
        },
        {
          path: '/recovery', name: 'PasswordRecovery', component: PasswordRecovery,
          meta: {
            title: 'Восстановление пароля',
            canViewGuest: true
          }
        },
        {
          path: '/password_reset/:uid/:token', name: 'PasswordReset', component: PasswordReset, props: true,
          meta: {
            title: 'Установка нового пароля',
            canViewGuest: true
          }
        },
        {
          path: 'operator', name: 'operator', component: OperatorList,
          meta: {
            title: 'Список новых заявлений',
            canViewStaff: true,
          }
        },
        {
          path: 'admin', name: 'admin', component: AdminList,
          meta: {
            title: 'Панель администратора',
            canViewStaff: true,
          }
        },
        {
          path: 'operator_profile', name: 'operator_profile', component: OperatorProfile,
          meta: {
            title: 'Личный кабинет оператора',
            canViewStaff: true,
          }
        },
        {
          path: 'operator_protector', name: 'operator_protector', component: OperatorProtector,
          meta: {
            title: 'Протекторат',
            canViewStaff: true,
          }
        },
        {
          path: 'operator_check_application/:id',
          name: 'operator_check_application',
          component: OperatorCheckApplication,
          meta: {
            title: 'Проверка заявлений',
            canViewStaff: true,
          }
        },
      ]
    },
    {
      path: '/profile',
      component: Layout,
      children: [
        {
          path: "", name: "profile", redirect: {
            name: "profile_application_list"
          }
        },
        {
          path: 'personal', name: 'profile_personal', component: ProfilePersonal,
          meta: {
            title: 'Персональные данные',
            canViewNewAbit: true
          }
        },
        {
          path: 'settings', name: 'profile_settings', component: ProfileSettings,
          meta: {
            title: 'Настройки',
            canViewAuth: true
          }
        },
        {
          path: "application", name: "profile_application", component: ProfileApplicationCreate,
          meta: {
            title: 'Черновик заявления',
            canViewAbit: true
          }
        },
        {
          path: "applications", name: "profile_application_list", component: ProfileApplicationList,
          meta: {
            title: 'Мои заявления',
            canViewAbit: true
          }
        },
        {
          path: "application/reset", name: "profile_application_reset", component: ProfileApplicationReset,
          meta: {
            title: 'Новое заявление',
            canViewAbit: true
          }
        },
        {
          path: "detail/:id", name: "profile_application_detail", component: ProfileApplicationDetail, props: true,
          meta: {
            title: 'Просмотр заявления',
            canViewAbit: true
          }
        },
      ]
    },
    {
      path: '/404', name: "page_not_found", component: PageNotFound,
      meta: {
        title: "Страница не найдена",
        canViewAll: true
      }
    },
    {path: '*', redirect: '/404'},
  ]
});


router.beforeEach(async (to, from, next) => {
  const canViewAll = to.matched.some(record => record.meta.canViewAll);
  const canViewGuest = to.matched.some(record => record.meta.canViewGuest);
  const canViewAuth = to.matched.some(record => record.meta.canViewAuth);
  const canViewNewAbit = to.matched.some(record => record.meta.canViewNewAbit);
  const canViewAbit = to.matched.some(record => record.meta.canViewAbit);
  const canViewStaff = to.matched.some(record => record.meta.canViewStaff);


  Promise.all([
    Store.dispatch('auth/authStatus'),
    Store.dispatch('abiturient/loadAbiturient'),
  ]).finally(() => {
    const user = Store.getters['auth/user'];
    const abiturient = Store.getters['abiturient/abiturient'];
    const isAuthenticated = Store.getters['auth/is_authenticated'];
    const isSuperuser = user.is_superuser;
    const isStaff = user.is_staff;
    const isNewAbit = user.is_abit && !abiturient.personal_data_completed;
    const isAbit = user.is_abit && abiturient.personal_data_completed;

    if (canViewAll) {
      return next()
    }

    if (isAuthenticated) {
      if (canViewGuest) {
        return next({name: 'profile'})
      }
      if (canViewAuth) {
        return next()
      }
      if (canViewNewAbit) {
        if (isNewAbit) {
          return next()
        } else if (isAbit) {
          return next({name: 'profile_application_list'})
        } else if (isStaff) {
          return next({name: 'operator'})
        }
      }
      if (canViewAbit) {
        if (isAbit) {
          return next()
        } else if (isNewAbit) {
          return next({name: 'profile_personal'})
        } else if (isStaff) {
          return next({name: 'operator'})
        }
      }
      if (canViewStaff) {
        if (isStaff || isSuperuser) {
          return next()
        } else {
          return next({name: 'page_not_found'})
        }
      }
      if (isSuperuser) {
        return next()
      }
    } else {
      if (canViewGuest) {
        return next()
      } else {
        return next({name: 'login', params: {nextUrl: to.fullPath}})
      }
    }
  })

});
router.beforeResolve((to, from, next) => {
  document.title = to.meta.title || 'Абитуриент КузГТУ';

  if (to.name) Store.commit('overlay/SHOW_OVERLAY');
  next()
});
router.afterEach(() => {
  Store.commit('overlay/HIDE_OVERLAY')
});

export default router
